export default "/images/Pro-4.png?da10828664c0d60f118ad981aa12a4ae";